import React,{useState,useEffect,useRef}from 'react'
import { Modal,Form,Input, App, } from 'antd';
import Icon from '../../../cpn/Icon';
import { useKaipiaolxUpdateSaveMutation } from '../../../store/DianShangYeWuApi';  
function InvoiceTypeEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        kplx_name:props.kplx_name,
        kplx_qy_id:props.qy_id,
        kplx_qy_name:props.qy_name,
        kplx_cid:props.yh_id,
        kplx_cname:props.yh_name,
        kplx_id:props.kplx_id,
    }); 
    const editForm = useRef()
    useEffect(() => {
        if(editForm.current){   
            editForm.current.setFieldsValue({
                kplx_name:props.kplx_name,
            })   
        }
    },[open ,props.kplx_name])
    const [kplxEdit] = useKaipiaolxUpdateSaveMutation()    
    return (
        <>
            <Icon type='edit' onClick={() => {setOpen(true)}} />
            <Modal
                width={1000}                        
                open={open}
                title='修改发票类型'
                okText="保存"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {                    
                    form
                        .validateFields()
                        .then((values) => {
                            kplxEdit(info).then((res) => {
                                // console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('修改成功')   
                                    setOpen(false);
                                    form.resetFields();
                                    onCreateEdit(values);
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('修改失败：'+res.data.Message)
                                }
                            })
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_kplx_edit_${props.yh_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <Form.Item name="kplx_name" wrapperCol={{span:4}} required label='名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,kplx_name:e.target.value}))
                        }}/>
                    </Form.Item>                                           
                </Form>
            </Modal>
        </>
    )
}

export default InvoiceTypeEdit